<section class="flex flex-col gap-4 rounded w-138 h-full min-h-[55vh]">
  @if (routes().length > 0) {
    <section #routesRow class="flex flex-row gap-2 relative items-center shrink-0">
      <section #measuringRow aria-hidden="true" class="flex flex-row gap-2 items-center absolute invisible pointer-events-none w-max">
        <img [src]="images.route" class="w-5 h-5" />
        @for (route of routes(); track $index) {
          <div class="route-chip date-selector flex flex-row gap-1 items-center p-2 border rounded" [ngClass]="{ 'font-bold': route.route.id === selectedRoute?.route?.id }">
            <span class="whitespace-nowrap">{{ route.route.name }}</span>
          </div>
        }
      </section>
      <img [src]="images.route" class="w-5 h-5 filter-primary-purple-light" />
      @for (route of visibleRoutes; track $index) {
        <div
          class="route-chip date-selector flex flex-row gap-1 items-center p-2 cursor-pointer border rounded min-w-0"
          [ngClass]="{
            'border-primary-purple-light! text-primary-purple-light bg-primary-purple-light-2 font-bold': route.route.id === selectedRoute?.route?.id,
            'bg-neutrals-white': route.route.id !== selectedRoute?.route?.id,
            'max-w-1/3 overflow-hidden': isOverflowing
          }"
          (click)="onRouteChange(route)">
          <span [id]="`preview-route-${$index}`" class="min-w-0" [ngClass]="{ 'truncate': isOverflowing }" [tooltip]="route.route.name" [visibleTooltip]="utilsService.visibleTooltip(`preview-route-${$index}`)" [position]="TooltipPosition.ABOVE">
            {{ route.route.name }}
          </span>
        </div>
      }
      @if (hiddenRoutes.length > 0) {
        <details class="dropdown dropdown-end" #routesDropdown (focusout)="closeDropdownOnFocusout($event, routesDropdown)">
          <summary class="list-none date-selector flex flex-row gap-1 items-center p-2 cursor-pointer border rounded tracking-wider" [ngClass]=" moreOptionsOpened ? 'border-primary-purple-light! text-primary-purple-light bg-primary-purple-light-2 font-bold' : 'bg-neutrals-white'">
            ...
          </summary>
          <div tabindex="0" class="dropdown-content z-10 mt-1 rounded flex flex-col gap-2.5 bg-primary-purple-light-2 p-2.5 shadow">
            <div class="w-full flex items-center gap-2 border-neutrals-grey-04 border rounded p-2">
              <img [src]="images.search" class="w-5 h-5" />
              <input class="w-full" [placeholder]="literalService.get('search', true) + '...'" (keydown)="onRouteSearch($event)" />
            </div>
            <div class="flex flex-col gap-1.5 scrollable-content max-h-72.5 w-3xs">
              @for (route of filteredRoutes; track $index) {
                <div 
                  class="date-item cursor-pointer flex gap-2 truncate rounded items-center h-8 shrink-0 pr-3" [ngClass]="route.route.id === selectedRoute?.route?.id ? 'font-bold pl-2' : 'pl-8'" 
                  (click)="onRouteChange(route); routesDropdown.removeAttribute('open')"
                >
                  @if (route.route.id === selectedRoute?.route?.id) {
                    <img [src]="images.check" class="w-4 h-4" />
                  }
                  <span [id]="`preview-all-routes-${$index}`" class="truncate min-w-0" [tooltip]="route.route.name" [visibleTooltip]="utilsService.visibleTooltip(`preview-all-routes-${$index}`)" [position]="TooltipPosition.DYNAMIC">
                    {{ route.route.name }}
                  </span>
                </div>
              }
            </div>
          </div>
        </details>
      }
    </section>
  }
  <section class="flex flex-row gap-4 relative shrink-0">
    <div class="relative flex gap-2 items-center">
      <img [src]="images.sidebar.trips" class="w-5 h-5 filter-primary-purple-light" />
      @if (selectedDate !== '') {
        <details class="dropdown" #datesDropdown (focusout)="closeDropdownOnFocusout($event, datesDropdown)">
          <summary class="list-none date-selector flex flex-row gap-1 items-center px-1 cursor-pointer">
            <span class="relative font-bold">
              <span class="invisible select-none grid" aria-hidden="true">
                @for (date of datesList; track $index) {
                  <span class="col-start-1 row-start-1 whitespace-nowrap">{{ formatDate(date.date) }}</span>
                }
              </span>
              <span class="absolute left-0 top-0 whitespace-nowrap">{{ formatDate(selectedDate) }}</span>
            </span>
            @if (datesList.length > 1) {
              <img [src]="images.arrowDown" class="w-2.5 h-2.5" />
            }
          </summary>
          <div tabindex="0" class="dropdown-content dates-dropdown z-10 mt-1 rounded flex flex-col">
            @for (date of datesList; track $index) {
              @if (date.date !== selectedDate) {
                <div class="date-item cursor-pointer px-2.5 py-1" (click)="onDateChange(date.date); datesDropdown.removeAttribute('open')">
                  {{ formatDate(date.date) }}
                </div>
              }
            }
          </div>
        </details>
      } @else {
        <span class="text-lg font-bold">-</span>
      }
    </div>
    @if (selectedTrip) {
      <div class="flex flex-row gap-2">
        <div class="hours-arrows rounded-sm w-5 h-5 flex justify-center items-center cursor-pointer" [ngClass]="{'disabled cursor-default!': isArrowDisabled(true)}" (click)="onTripChange(true)">
          <img [src]="images.arrowLeft" class="w-2.5 h-2.5" alt="arrowLeft" />
        </div>
        <span class="font-bold">{{ selectedTrip?.time }}</span>
        <div class="hours-arrows rounded-sm w-5 h-5 flex justify-center items-center cursor-pointer" [ngClass]="{'disabled cursor-default!': isArrowDisabled(false)}" (click)="onTripChange(false)">
          <img [src]="images.arrowRight" class="w-2.5 h-2.5" />
        </div>
      </div>
      @if (expeditionStatus) {
        <div class="font-bold">
          {{ literalService.get(expeditionStatus.toLowerCase(), true) }}
        </div>
      }
      @if (allowExcluding()) {
        <app-checkbox
          class="absolute right-0 top-1"
          [id]="'excludeTrip'"
          [checked]="exludedTripIds()?.includes(selectedTrip?.id)"
          [value]="{name: literalService.get('services.routes.design.update.review.doNotUpdate', true)}"
          (onChange)="onChangeExcludedTrip($event)"
        />
      }
    }
  </section>
  <section id="previewChangesList" class="scrollable-content flex-1 min-h-0" [ngClass]="{'flex items-center' : filteredBookings.length === 0, 'bg-white rounded flex justify-center items-center': filteredBookings.length === 0 && !(loadingDates || loadingBookings())}">
    @if (loadingDates || loadingBookings()) {
      <ngx-skeleton-loader count="10" appearance="line" [theme]="{ 'height': '45px', 'margin-bottom': '0' }"></ngx-skeleton-loader>
    } @else {
      @if (filteredBookings.length === 0) {
        <div class="w-full h-full flex flex-col justify-center items-center gap-8">
          <img [src]="images.routes.emptyStatePreview" class="w-33 h-34.25" alt="noAffectations" />
          <span class="font-bold text-neutrals-grey-04 text-center text-2xl">
            {{ literalService.get('services.routes.design.update.noAffectations', true) }}
          </span>
        </div>
      } @else {
        @for (booking of filteredBookings; track $index) {
          <div class="w-full border border-neutrals-grey-02 bg-white grid grid-cols-[repeat(12,1fr)] py-1 -mb-px" [ngClass]="{'disabled-row': exludedTripIds()?.includes(booking.tripId)}">
            <div class="flex gap-2.5 border-r border-neutrals-grey-02 col-span-2 justify-center items-center">
              <div [tooltip]="literalService.get( booking.reason ? `services.routes.design.previewReasons.${booking.reason}` : `services.routes.design.previewReasons.${booking.toRedo ? 'willRedo' : 'willCancel'}`, true)" [position]="TooltipPosition.BELOW_RIGHT">
                @if (booking.toRedo) {
                  <img [src]="images.redo" class="w-6 h-6 filter-primary-purple-light" alt="redo" />
                } @else {
                  <img [src]="images.cancelCircle" class="w-6 h-6 filter-secondary-red" alt="cancel"/>
                }
              </div>
              <div>
                @if (booking.channel === BookingOrigin.BackOffice) {
                  <img [src]="images.booking.notified.phone" class="w-6 h-6" alt="phone" />
                } @else if (booking.channel === BookingOrigin.UserApp) {
                  <img [src]="images.booking.notified.app" class="w-6 h-6" alt="app" />
                } @else if (booking.channel === BookingOrigin.WhatsApp) {
                  <img [src]="images.booking.notified.whatsapp" class="w-6 h-6" alt="whatsApp" />
                } @else {
                  <img [src]="images.booking.notified.phone" class="w-6 h-6" alt="phone"/>
                }
              </div>
            </div>
            <div class="border-r border-neutrals-grey-02 col-span-3 flex justify-center items-center text-center">
              {{ `${booking.firstName} ${booking.lastName}` }}
            </div>
            <div class="border-r border-neutrals-grey-02 col-span-6 ml-5 flex items-center">
              <div class="flex flex-col gap-1.5 truncate">
                <div class="flex justify-start items-center">
                  <app-marker-od id="origin" [textColor]="'text-white'" [color]="'bg-primary-purple-light'" [size]="4"></app-marker-od>
                  <label [id]="'origin-'+$index" class="truncate text-sm ml-2" [tooltip]="utilsService.visibleTooltip('origin-'+$index!) ? booking.origin.name! : ''" [visibleTooltip]="utilsService.visibleTooltip('origin-'+$index!)" [position]="TooltipPosition.ABOVE">{{ booking.origin.name }}</label>
                </div>
                <div class="flex justify-start items-center">
                  <app-marker-od id="destination" [textColor]="'text-black'" [color]="'bg-primary-green'" [size]="4"></app-marker-od>
                  <label [id]="'destination-'+$index" class="truncate text-sm ml-2" [tooltip]="utilsService.visibleTooltip('destination-'+$index!) ? booking.destination.name! : ''" [visibleTooltip]="utilsService.visibleTooltip('destination-'+$index!)" [position]="TooltipPosition.ABOVE">{{ booking.destination.name }}</label>
                </div>
              </div>
            </div>
            <div class="col-span-1 flex justify-center items-center">
              <a class="w-full flex justify-center items-center"
                [href]="router.serializeUrl(router.createUrlTree(['/bookings', booking.id]))"
                target="_blank">
                <img [src]="images.externalLink" class="h-6 w-6 cursor-pointer" [tooltip]="literalService.get('trips.modal.bookings.button', true)" [position]="TooltipPosition.ABOVE" />
              </a>
            </div>
          </div>
        }
      }
    }
  </section>
</section>